import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { serviceService } from '../../services/serviceService';
import ServiceForm from '../../components/Services/ServiceForm';
import Toast from '../../components/Common/Toast';

const EditService = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [service, setService] = useState(null);
  const [loading, setLoading] = useState(true);
  const [toast, setToast] = useState({ isOpen: false, message: '', type: 'info' });

  useEffect(() => {
    const loadService = async () => {
      try {
        console.log('📡 [EditService] Cargando servicio ID:', id);
        const response = await serviceService.getService(id);
        
        if (response.success && response.data) {
          console.log('✅ [EditService] Servicio cargado:', response.data);
          setService({ ...response.data, id: parseInt(id) });
        } else {
          console.warn('⚠️ [EditService] Servicio no encontrado');
          setToast({
            isOpen: true,
            message: 'Servicio no encontrado',
            type: 'error'
          });
          setTimeout(() => {
            navigate('/services');
          }, 2000);
        }
      } catch (error) {
        console.error('❌ [EditService] Error al cargar servicio:', error);
        setToast({
          isOpen: true,
          message: error.response?.data?.message || 'Error al cargar el servicio',
          type: 'error'
        });
        setTimeout(() => {
          navigate('/services');
        }, 2000);
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      loadService();
    }
  }, [id, navigate]);

  const handleSuccess = () => {
    setToast({
      isOpen: true,
      message: 'Servicio actualizado exitosamente',
      type: 'success'
    });
    setTimeout(() => {
      navigate('/services');
    }, 1500);
  };

  const handleCancel = () => {
    navigate('/services');
  };

  if (loading) {
    return (
      <div className="p-6">
        <div className="max-w-5xl mx-auto">
          <div className="text-center py-12">
            <div className="text-gray-500">Cargando...</div>
          </div>
        </div>
      </div>
    );
  }

  if (!service) {
    return null;
  }

  return (
    <div className="p-6">
      <div className="max-w-5xl mx-auto">
        {/* Header */}
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-800">Editar Servicio</h1>
          <p className="text-gray-600 mt-1">Modifique la información del servicio</p>
          <div className="mt-2">
            <span className="text-sm font-mono text-teal-600">SKU: {service.sku}</span>
          </div>
        </div>

        {/* Formulario */}
        <ServiceForm
          isOpen={true}
          onClose={handleCancel}
          service={service}
          onSuccess={handleSuccess}
          isPageMode={true}
        />

        {/* Toast de notificaciones */}
        <Toast
          isOpen={toast.isOpen}
          message={toast.message}
          type={toast.type}
          onClose={() => setToast({ ...toast, isOpen: false })}
        />
      </div>
    </div>
  );
};

export default EditService;






